export default "__VITE_ASSET__DYODB8cz__"